import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import SearchResults from './SearchResults';
interface LayoutProps {
  children: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  return <div className="flex min-h-screen bg-gray-50" data-id="element-75">
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} data-id="element-76" />
      <div className="flex-1 lg:ml-64" data-id="element-77">
        <Header setSidebarOpen={setSidebarOpen} setSearchResults={setSearchResults} setShowSearchResults={setShowSearchResults} data-id="element-78" />
        <main className="px-4 py-6 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-79">
          {showSearchResults ? <SearchResults results={searchResults} setShowSearchResults={setShowSearchResults} data-id="element-80" /> : children}
        </main>
        <footer className="bg-white p-6 border-t border-gray-200" data-id="element-81">
          <div className="max-w-7xl mx-auto text-center text-sm text-gray-500" data-id="element-82">
            <p data-id="element-83">
              Post-Clinical Cancer Network Guidelines for Non-Small Cell Lung
              Cancer (NSCLC)
            </p>
            <p data-id="element-84">v.1.0.0 October 2025</p>
          </div>
        </footer>
      </div>
    </div>;
};
export default Layout;